import Button from '@/features/shared/Button';
import ContentContainer from '@/features/shared/ContentContainer';
import FourFiveColumnContent from '@/features/shared/FourFiveColumnContent';
import { MuiContainer, MuiTypography } from '@/features/shared/material-ui';
import { Theme } from '@/utils/constants';
import clsx from 'clsx';
import React, { memo } from 'react';
import { FeaturedContentProps } from '../FeaturedContent.interface';
import { CtaCard } from '../shared/CtaCard';
import { RowCard } from '../shared/RowCard';
import useStyles from './Grid.styles';

const GridCard = ({
  card,
  styles,
  showCaption,
  hideImage,
  hideDescription,
  cardVerticalAlignmentNoImage,
}: any) => {
  if (/image/.test(card.variant)) {
    return <CtaCard cardImage={card.image} {...styles} />;
  }

  return (
    <RowCard
      {...card}
      {...styles}
      showCaption={showCaption}
      hideImage={hideImage}
      hideDescription={hideDescription}
      cardVerticalAlignmentNoImage={cardVerticalAlignmentNoImage}
    />
  );
};

const Grid = ({
  curatedList,
  contentButtons,
  cardColor,
  theme = Theme.light,
  cardTheme,
  presentation,
  isCardImages,
  showCaption,
}: Partial<FeaturedContentProps>) => {
  const classes = useStyles({});
  const rootClassName = clsx(classes.root, `${theme}-theme`, 'gtm-headline-container');
  const { contentList = [], listSuperheading, listTitle, cta } = curatedList || {};
  const filterContentList = contentList;
  const {
    topSpacing,
    bottomSpacing,
    topBackgroundColor,
    bottomBackgroundColor,
    cardVerticalAlignmentNoImage = 'center',
  } = presentation || {};

  const styles = {
    cardColor,
    cardTheme,
    theme,
  };

  return (
    <ContentContainer
      topSpacing={topSpacing}
      bottomSpacing={bottomSpacing}
      topBackgroundColor={topBackgroundColor}
      bottomBackgroundColor={bottomBackgroundColor}
    >
      <MuiContainer>
        {contentButtons?.curatedList}
        <div className={rootClassName}>
          {(listSuperheading || listTitle) && (
            <div className={classes.headerCard}>
              {listSuperheading && (
                <MuiTypography variant="overline" component="div" className={classes.superHeading}>
                  {listSuperheading}
                </MuiTypography>
              )}
              {listTitle && (
                <MuiTypography
                  variant="h4"
                  component="h3"
                  className={clsx(classes.title, 'gtm-headline')}
                >
                  {listTitle}
                </MuiTypography>
              )}
            </div>
          )}
          {filterContentList.length > 0 && (
            <FourFiveColumnContent
              className={classes.contentCards}
              columnCount={3}
              columns={filterContentList.map((card: any, idx: number) => {
                return (
                  <GridCard
                    // eslint-disable-next-line react/no-array-index-key
                    key={`card_${idx}`}
                    card={card}
                    styles={styles}
                    showCaption={showCaption}
                    hideImage={!isCardImages}
                    cardVerticalAlignmentNoImage={cardVerticalAlignmentNoImage}
                  />
                );
              })}
            />
          )}
          {cta?.displayText && (
            <div className={classes.ctaWrapper}>
              <Button link={cta} theme={theme} className="gtm-see-all" />{' '}
            </div>
          )}
        </div>
      </MuiContainer>
    </ContentContainer>
  );
};

export default memo(Grid);
